import { keyframes } from "@emotion/react";
import styled from "@emotion/styled";
import * as Accordion from "@radix-ui/react-accordion";
import React from "react";
import { CHEVRON_DOWN_ICON_THIN } from "../../utils/svgs_new";
import { AppIcon } from "../Generic/AppIcon";

function OnboardingAccordion() {
  return null;
}

const slideDown = keyframes`
  from {
    height: 0;
  }
  to {
    height: var(--radix-accordion-content-height);
  }`;

const slideUp = keyframes`
  from {
    height: var(--radix-accordion-content-height);
  }
  to {
    height: 0;
  }`;

const AccordionChevronWrapper = styled(AppIcon)`
  transition: transform 300ms cubic-bezier(0.87, 0, 0.13, 1);
  transform: rotate(-90deg);
`;

const OnboardingAccordionTrigger = styled(Accordion.Trigger)``;

const OnboardingAccordionRoot = styled(Accordion.Root)`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const OnboardingAccordionContent = styled(Accordion.Content)`
  overflow: hidden;

  &[data-state="open"] {
    animation: ${slideDown} 300ms ease-out;
  }

  &[data-state="closed"] {
    animation: ${slideUp} 300ms ease-out;
  }
`;

const OnboardingAccordionItem = styled(Accordion.Item)`
  &[data-state="open"] [data-is-collapsible="true"] ${AccordionChevronWrapper} {
    transform: rotate(0);
  }
`;

function Chevron(props: { size: number; isCollapsible: boolean }) {
  return (
    <div data-is-collapsible={props.isCollapsible}>
      <AccordionChevronWrapper
        size={props.size}
        icon={CHEVRON_DOWN_ICON_THIN}
        fill={"var(--tw-slate-600)"}
      />
    </div>
  );
}

OnboardingAccordion.Trigger = OnboardingAccordionTrigger;
OnboardingAccordion.Root = OnboardingAccordionRoot;
OnboardingAccordion.Content = OnboardingAccordionContent;
OnboardingAccordion.Item = OnboardingAccordionItem;
OnboardingAccordion.Chevron = Chevron;

export default OnboardingAccordion;
